/**
 * Old links arrive as /app.html-style hashes (e.g. "#call/CA123", "#new/+15551234"),
 * from bookmarks, notifications and server redirects. Map them to clean paths
 * before the router mounts.
 */
const HASH_ROUTES: Record<string, string> = {
  home: '/',
  calls: '/calls',
  new: '/new',
  settings: '/settings',
  contacts: '/contacts',
  verification: '/verification',
  credits: '/credits',
  subscription: '/subscription',
  subscription_business: '/subscription/business',
  business_details: '/settings/business',
  keys: '/keys',
}

export function redirectLegacyHash() {
  const hash = window.location.hash.replace(/^#/, '')
  if (!hash) return

  const [head, ...rest] = hash.split('/')
  let path: string | undefined

  if ((head === 'call' || head === 'live' || head === 'new') && rest.length > 0) {
    path = `/${head}/${rest.join('/')}`
  } else if (HASH_ROUTES[head]) {
    path = HASH_ROUTES[head]
  }

  if (path) {
    history.replaceState(null, '', path)
  }
}
